import React from 'react';
import Ribbon from '.';
function RibbonSeparator({ offset, color_left, color_right }) {
    const { size } = offset || {};
    const offsetInt = parseInt(size) || 0;
    const flexBasisLeft = `${offsetInt}%`;
    const flexBasisRight = `${100 - offsetInt}%`;
    return (React.createElement("div", { className: "ltg-ribbon-separator" },
        React.createElement("div", { className: `ribbon-filler bg-${color_left || 'black'}` }),
        React.createElement("div", { className: "container" },
            React.createElement("div", { className: "ribbon-wrap", style: { flexBasis: flexBasisLeft } },
                React.createElement(Ribbon, { side: "left", color: color_left || 'black' })),
            React.createElement("div", { className: "ribbon-wrap", style: { flexBasis: flexBasisRight } },
                React.createElement(Ribbon, { side: 'right', color: color_right || 'primary' }))),
        React.createElement("div", { className: `ribbon-filler bg-${color_right || 'primary'}` })));
}
export function RibbonSeparatorGtc({ offset, color_left, color_right }) {
    const bg_color = color_left || 'primary';
    const fill_color = color_right || 'white';
    return React.createElement("div", { className: "ltg-ribbon-separator-dots" },
        React.createElement("div", { className: `ltg-ribbon-track bg-${bg_color}` }),
        React.createElement("div", { className: "container" },
            React.createElement("div", { className: `ltg-ribbon-dot bg-${bg_color} dot-bg-${fill_color}`, style: { left: `${(offset === null || offset === void 0 ? void 0 : offset.size) || 20}%` } }),
            React.createElement("div", { className: `ltg-ribbon-dot --left bg-${bg_color} dot-bg-${fill_color}` }),
            React.createElement("div", { className: `ltg-ribbon-dot --right bg-${bg_color} dot-bg-${fill_color}` })));
}
function RibbonMuseum({ vertical }) {
    return React.createElement("div", { className: `ltg-ribbon-museum${vertical ? ' --vertical' : ''}` });
}
let Separator;
switch (THEME) {
    case ('gtc'):
        Separator = RibbonSeparatorGtc;
        break;
    case ('museum'):
        Separator = RibbonMuseum;
        break;
    default:
        Separator = RibbonSeparator;
        break;
}
export { Separator as default };
// function ThemedSeparator(props:any){
// 	let Separator:(props:RibbonSeparatorProps) => React.ReactElement;
// 	switch(THEME){
// 		case('gtc'):
// 			Separator = RibbonSeparatorGtc
// 		break;
// 		case('museum'):
// 			Separator = RibbonMuseum
// 		break;
// 		default:
// 			Separator = RibbonSeparator
// 		break;
// 	}
// 	return <Separator {...props}/>
// }
// export { ThemedSeparator as default }
